import Pristine from 'pristinejs';

const BPR_NUMBER_REGEX = RegExp("^[0-9]{6}$"); 

class Step2ComplaintFieldsetValidation {

    constructor(form) {
        this.complaintForm = form;
        this.formValidation = null;
        this.pristineConfig =  {
            classTo: 'form-group',
        
            errorClass: 'form-error',
            successClass: 'form-valid',
        
            errorTextParent: 'form-group',
            errorTextTag: 'label',
            errorTextClass: 'form-error-text',
          }
        this.setup();
    }

    //
    // Methods for preparing / resetting form state
    //

    setup() {
        // console.log("Setting up frontend validation...");
        this.reset_form_validation();

        if(this.is_tn_lawyer_checkbox_selected()) {
            // console.log('Enabling lawyer BPR validations...');
            this.add_complaintant_bpr_number_validation();
        }

        if(this.is_complaintant_contact_required()) {
            // console.log('Enabling complaintant contact validations...');
            this.add_complaintant_contact_validation_requirements();
        }
        
        if (this.is_alt_contact_checkbox_selected()) {
            // console.log('Enabling alt contact validations...');
            this.add_custom_alternate_contact_validation_requirements();
        }

        // console.log("Done");
    }

    reset_form_validation() {
        // To prepare to validate, clear the slate and start a new validator so that if the status of the 
        // alternate contact check box changes, the requirement that the fields be present changes.
        if (this.formValidation != null) {
            this.formValidation.reset();
            this.formValidation.destroy();
        }
        this.formValidation = new Pristine(this.complaintForm, this.pristineConfig);
    }

    stripped_lower_case_value(input_field_id) {
        let field = document.getElementById(input_field_id);
        if (field) {
          return field.value.toLowerCase().trim();
        } else {
          return "";
        }
      }
      
    reset_field_value(input_field_id) {
        let field = document.getElementById(input_field_id);
        if (field) {
          field.value = '';
        }
    }

    //
    // Checkbox Status Checking Methods
    //
    is_checkbox_selected(checkbox_id) {
        try {
            var checkbox = document.getElementById(checkbox_id);
            return checkbox && checkbox.checked === true;
        } catch {
            console.error("Error accessing " + checkbox_id + " checkbox:", error);
            return false;
        }
    }

    is_alt_contact_checkbox_selected() {
        return this.is_checkbox_selected(
            "file_complaint_step2_complaint_fieldset_alternative-contact"
        );
    }

    is_tn_lawyer_checkbox_selected() {
        return this.is_checkbox_selected(
            "file_complaint_step2_complaint_fieldset_is_tn_lawyer"
        );
    }

    is_complaintant_contact_required() {
        return !this.is_tn_lawyer_checkbox_selected();
    }

    //
    // Add Pristine Custom Verification as Needed
    //

    alt_contact_css_id(id) {
        return "file_complaint_step2_complaint_fieldset_complaintant_people_" + id;
    }

    complaintant_css_id(id) {
        return "file_complaint_step2_complaint_fieldset_home_addresses_" + id;
    }

    add_custom_alternate_contact_validation_requirements()  {
        // Add conditional alternate contact validation required fields
        let conditionallyRequiredFields = document.querySelectorAll('[data-alt-contact-conditionally-required="true"]');
      
        conditionallyRequiredFields.forEach((field) => {
          // Add required validation to the field
          this.formValidation.addValidator(field, (value) => {
              return !this.is_alt_contact_checkbox_selected() || value.length > 0;
          }, "This alternate contact field is required.", 2, false);
        });
      
        /* Additional fallback validation to make extra sure some important rules */
        var acEmailField = document.getElementById(this.alt_contact_css_id('email'));
        this.formValidation.addValidator(
          acEmailField, (value) => { 
            var complaintant_email = this.stripped_lower_case_value(this.complaintant_css_id('email'));
            var alt_email = this.stripped_lower_case_value(this.alt_contact_css_id('email'));
            return alt_email !== complaintant_email;
          }, 
          'Your alternate contact must have a different e-mail address than your Personal Information e-mail.', 
          3, 
          false
        );
      
        let acCellPhoneField = document.getElementById(this.alt_contact_css_id('cell_phone'));
        this.formValidation.addValidator(
          acCellPhoneField, (value) => { 
            let alt_cell_phone = this.stripped_lower_case_value(this.alt_contact_css_id('cell_phone'));
            let complaintant_cell_phone = this.stripped_lower_case_value(this.complaintant_css_id('cell_phone'));
            return alt_cell_phone !== complaintant_cell_phone;
          }, 
          'Your alternate contact must have a different cell phone number than your Personal Information cell phone number.', 
          3, 
          false
        );
    }

    add_complaintant_contact_validation_requirements() {
        let conditionallyRequiredFields = document.querySelectorAll('[data-complaintant-conditionally-required="true"]');
      
        conditionallyRequiredFields.forEach((field) => {
            this.formValidation.addValidator(field, (value) => {
                return !this.is_complaintant_contact_required() || value.length > 0;
            }, "This contact field is required.", 2, false);
        });
    }
      
    add_complaintant_bpr_number_validation() {
        let field = document.getElementById('complaintant_bpr_number');
      
        // console.log("Adding custom validation to BPR field: " + this.formValidation);
        // Field is required unless the checkbox is unchecked
        this.formValidation.addValidator(field, (value) => {
            return !this.is_tn_lawyer_checkbox_selected() || BPR_NUMBER_REGEX.test(value);
        }, "Your BPR number is required since you are a TN lawyer. A valid number is six digits long.", 2, false);
    }



    validate() {
        return this.formValidation.validate();
    }
      
} // end class


document.addEventListener('DOMContentLoaded', () => {
    if ($('#file_complaint_step2_complaint_fieldset_complaintant_people_first_name').length > 0) {
        var form = document.getElementById('new_complaint');
        var validator = new Step2ComplaintFieldsetValidation(form);
        window.step_validator = validator;

        form.addEventListener('submit', function(e) { 
            // console.log("Form submit started.");
            window.step_validator.setup();   
            if (!window.step_validator.validate())
            {
                // Stop the form from submitting because it is invalid
                e.preventDefault();
            }
            // console.log("Done");
        });
    }
});